export default "__VITE_ASSET__CCVeR1ZR__"